import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

import {Icon, Message} from "semantic-ui-react";

import {signInByToken} from "../../actions/signIn";

class SignInByToken extends Component {

    componentDidMount() {
        if (!this.props.authenticated && this.props.match.params.token) {
            this.props.dispatch(signInByToken(this.props.match.params.token));
        } else {
            this.props.history.push("/");
        }
    }

    componentDidUpdate() {
        if (!this.props.authenticated && this.props.match.params.token) {
            this.props.dispatch(signInByToken(this.props.match.params.token));
        } else {
            this.props.history.push("/");
        }
    }

    render() {
        return (
            <div style={{margin: "1rem auto", maxWidth: "768px"}}>
                {this.props.signing && <Message icon>
                    <Icon name='circle notched' loading/>
                    <Message.Content style={{textAlign: "left"}}>Trwa logowanie</Message.Content>
                </Message>}
                {this.props.error && <Message icon negative>
                    <Icon name="exclamation triangle"/>
                    <Message.Content style={{textAlign: "left"}}>Logowanie nie powiodło
                        się. {this.props.error}</Message.Content>
                </Message>}
            </div>
        );
    }
};

function mapStateToProps(state) {
    return {
        authenticated: state.session.authenticated,
        signing: state.signIn.signing,
        error: state.signIn.error
    }
}

export default withRouter(connect(mapStateToProps)(SignInByToken))



// WEBPACK FOOTER //
// ./src/components/routes/SignInByToken.js